"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MentionElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _slateReact = require("slate-react");
var _jsxRuntime = require("react/jsx-runtime");
var MentionElement = exports.MentionElement = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    prefix = _ref.prefix,
    renderLabel = _ref.renderLabel,
    onClick = _ref.onClick,
    props = _objectWithoutProperties(_ref, ["children", "className", "prefix", "renderLabel", "onClick"]);
  var element = (0, _plateCommon.useElement)();
  var selected = (0, _slateReact.useSelected)();
  var focused = (0, _slateReact.useFocused)();
  var dataSlateValue = element.value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_plateCommon.PlateElement, _objectSpread({
    ref: ref,
    as: "span",
    className: (0, _cn.cn)('inline-block cursor-pointer rounded-md bg-muted px-1.5 py-0.5 align-baseline text-sm font-medium bg-blue-200', selected && focused && 'ring-2 ring-ring', element.children[0].bold === true && 'font-bold', element.children[0].italic === true && 'italic', element.children[0].underline === true && 'underline', className),
    onClick: (0, _plateCommon.getHandler)(onClick, element),
    "data-slate-value": dataSlateValue,
    contentEditable: false
  }, props, {
    children: [prefix, renderLabel ? renderLabel(element) : element.label, children === element.label ? null : children]
  }));
});